export const BASE_URL = "https://platform.tronog-engine.com"
export const LOGIN_URL = "https://platform.tronog-engine.com/auth/login?redirect="
